module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Transient. Ethereal. Delicate.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Insignificant.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mere insects …")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Like all the human beings trapped aboard a vast starship on a generations-long journey to a new home.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Mayflower is run by an immortal captain who views himself as a god.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Gerard Metaclura was just a normal man until a terrible accident left him near dead, his body destroyed. But his brain was installed as the sentient command core of the generation ship.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At first Gerard was confused by what had happened to him. Then angry. Then bored.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Now he is the ship, controlling everything on board … including 25,000 helpless human passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("These mayflies …")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Transient. Ethereal. Delicate.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But maybe they’re not willing to be so helpless and insignificant after all.…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("Mayflies")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0